import { render, staticRenderFns } from "./AutomationMarketing.vue?vue&type=template&id=57ac5800"
import script from "./AutomationMarketing.vue?vue&type=script&lang=js"
export * from "./AutomationMarketing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports